<template>
  <!-- 扫码入职首页 -->
  <div class="home">
    <!-- <van-nav-bar title="华跃科技有限公司" :fixed="true"> </van-nav-bar> -->
    <!-- <scanEntry/> -->
    <div class="content">
      <div class="swipe">
        <van-swipe :autoplay="3000"
                   height="300px">
          <van-swipe-item v-for="(image, index) in swipeImgs"
                          :key="index"
                          @click="gotoFuck(image)">
            <img height="100%"
                 width="100%"
                 v-lazy="image.url+'?timestamp='+ new Date().getTime()" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="video_box"
           v-if="home_m_show_video">
        <div class="video_title">{{vider_title}}</div>
        <video width="100%"
               height="100%"
               controls
               :poster="video_poster_url"
               :src="video_url"
               controlslist="nodownload"
               style="background: #000">
        </video>
      </div>
      <div class="navButton_box">
        <div class="bg_box">
          <div class="left">
            <div v-if="home_xzxy_title"
                 class="long_box"
                 @click="gotoPage(home_xzxy_title, 1)">
              <img src="@/assets/img/home_btn_01.png"
                   alt="" />
              <div>{{home_xzxy_title}}</div>
            </div>
            <div v-if="home_shzp_title"
                 class="square_box"
                 @click="gotoPage(home_shzp_title, 2)">
              <div class="bao">
                <img src="@/assets/img/home_btn_03.png"
                     alt="" />
                <div>{{home_shzp_title}}</div>
              </div>
            </div>
            <div v-if="home_cpyyy_title"
                 class="long_box"
                 @click="gotoPage(home_cpyyy_title, 3)">
              <img src="@/assets/img/home_btn_05.png"
                   alt="" />
              <div>{{home_cpyyy_title}}</div>
            </div>
            <div v-if="home_psh_title"
                 class="square_box"
                 @click="gotoPage(home_psh_title, 4)">
              <div class="bao">
                <img src="@/assets/img/home_btn_07.png"
                     alt="" />
                <div>{{home_psh_title}}</div>
              </div>
            </div>
          </div>
          <div class="fill_box"></div>
          <div class="right">
            <div v-if="home_xyzp_title"
                 class="square_box"
                 @click="gotoPage(home_xyzp_title, 5)">
              <div class="bao">
                <img src="@/assets/img/home_btn_02.png"
                     alt="" />
                <div>{{home_xyzp_title}}</div>
              </div>
            </div>
            <div v-if="home_gw_title"
                 class="long_box"
                 @click="gotoPage(home_gw_title, 6)">
              <img src="@/assets/img/home_btn_04.png"
                   alt="" />
              <div>{{home_gw_title}}</div>
            </div>
            <div v-if="home_xzdyfaq_title"
                 class="square_box"
                 @click="gotoPage(home_xzdyfaq_title, 7)">
              <div class="bao">
                <img src="@/assets/img/home_btn_06.png"
                     alt="" />
                <div>{{home_xzdyfaq_title}}</div>
              </div>
            </div>
            <div v-if="home_pxsd_title"
                 class="long_box"
                 @click="gotoPage(home_pxsd_title, 8)">
              <img src="@/assets/img/home_btn_08.png"
                   alt="" />
              <div>{{home_pxsd_title}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import scanEntry from './scanEntry'
import { getWxApiToken, getScanEntryHomeSet } from '@/request/api.js'
import { Base64 } from 'js-base64'
export default {
  components: {
    scanEntry
  },
  data () {
    return {
      Login_SwitchCount: 0,
      swipeImgs: [],
      home_m_show_video: false,
      vider_title: '',
      video_url: "",
      video_poster_url: '',
      home_xzxy_title: '', // '校招序言'
      home_shzp_title: '', // '社会招聘'
      home_cpyyy_title: '', // '产品与应用'
      home_psh_title: '', // 'π生活'
      home_xyzp_title: '', // '校园招聘'
      home_gw_title: '', // '官网标题'
      home_m_weburl: '', // 官网地址
      home_xzdyfaq_title: '', // '校招答疑FAQ'
      home_pxsd_title: '', // 'π新生代'
      home_xzxy_newsid: 0,
      home_cpyyy_newsid: 0,
      home_xzdyfaq_newsid: 0,
      home_psh_newsid: 0,
      home_pxsd_newsid: 0
    }
  },
  created () {
    getWxApiToken().then(res => {
      sessionStorage.setItem('token', res)
      // 获取参数
      getScanEntryHomeSet().then(res => {
        const data = res.data[0]
        this.Login_SwitchCount = data.login_switchcount
        this.swipeImgs = []
        for (let idx = 0; idx < this.Login_SwitchCount; idx++)
        {
          let index = idx + 1
          let obj = {
            index: index,
            url: data['topbg' + index + '_url'] || '',
            link: data['home_m_top' + index + '_jump_url'] || ''
          }
          this.swipeImgs.push(obj)
        }
        this.home_m_show_video = data.home_m_show_video
        this.vider_title = data.home_m_video_title
        this.video_url = data.video_url
        this.video_poster_url = data.video_poster_url

        this.home_xzxy_title = data.home_xzxy_title  // '校招序言'
        this.home_shzp_title = data.home_shzp_title  // '社会招聘'
        this.home_cpyyy_title = data.home_cpyyy_title  // '产品与应用'
        this.home_psh_title = data.home_psh_title  // 'π生活'
        this.home_xyzp_title = data.home_xyzp_title  // '校园招聘'
        this.home_xzdyfaq_title = data.home_xzdyfaq_title  // '校招答疑FAQ'
        this.home_pxsd_title = data.home_pxsd_title  // 'π新生代'

        this.home_gw_title = data.home_gw_title  // '官网'
        this.home_m_weburl = data.home_m_weburl

        this.home_xzxy_newsid = data.home_xzxy_newsid
        this.home_cpyyy_newsid = data.home_cpyyy_newsid
        this.home_xzdyfaq_newsid = data.home_xzdyfaq_newsid
        this.home_psh_newsid = data.home_psh_newsid
        this.home_pxsd_newsid = data.home_pxsd_newsid
        // 修改页面标题
        document.title = data.home_m_title
      })
    })
  },
  methods: {
    // 轮播图点击
    gotoFuck (image) {
      if (image.link)
      {
        window.open(image.link, '_blank')
      }
    },
    // 页面跳转
    gotoPage (name, code) {
      let imgName = ''
      if (code == 1)
      {
        // 校招序言 
        this.$router.push({
          path: "/newsDetails",
          query: { autoid: this.home_xzxy_newsid, title: name }
        })
      } else if (code == 2)
      {
        // 校招职位
        let autoid = localStorage.getItem('autoid')
        let attachfilepath = localStorage.getItem('attachfilepath')
        let istest = localStorage.getItem('istest')
        let tel = localStorage.getItem('phoneNum')
        if (autoid)
        {
          // 已登录跳转至岗位 
          const param = {
            module: 304,
            zpacid: '',
            tel: tel,
            restype: '',
            tj_empid: '',
            istest: istest,
            attachfilepath: attachfilepath,
            autoid: autoid
          }
          this.$router.push({
            path: "/seStaList",
            query: { param: Base64.encode(JSON.stringify(param)) }
          })
        } else
        {
          // 未登录跳转至登录页
          this.$router.push('/scanEntry?module=304')
        }
      } else if (code == 3)
      {
        // 产品与应用 
        this.$router.push({
          path: "/newsDetails",
          query: { autoid: this.home_cpyyy_newsid, title: name }
        })
      } else if (code == 4)
      {
        // π生活 
        this.$router.push({
          path: "/newsDetails",
          query: { autoid: this.home_psh_newsid, title: name }
        })
      } else if (code == 5)
      {
        // 宣讲行程
        this.$router.push({ path: '/lecture', query: { title: name } })
      } else if (code == 6)
      {
        // 官网 
        if (this.home_m_weburl)
        {
          window.open(this.home_m_weburl, '_blank')
        }
      } else if (code == 7)
      {
        // 校招答疑FAQ 
        this.$router.push({
          path: "/newsDetails",
          query: { autoid: this.home_xzdyfaq_newsid, title: name }
        })
      } else if (code == 8)
      {
        // π新生代 
        this.$router.push({
          path: "/newsDetails",
          query: { autoid: this.home_pxsd_newsid, title: name }
        })
      }
      if (imgName)
      {
        this.$router.push({
          path: '/commonPage',
          query: { title: name, imgName: imgName }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  height: 100vh;
  background-color: #e9eaec;
  overflow: hidden;
  .van-nav-bar {
    height: 92px;
    background: #bcdfff;
    position: fixed !important;
    /deep/.van-nav-bar__title {
      color: #333;
      font-size: 36px;
      font-weight: bold;
      font-family: Source Han Sans CN;
    }
  }
  .van-hairline--bottom::after {
    border: 0;
  }
  .content {
    height: 100%;
    // height: calc(100% - 92px);
    // margin-top: 92px;
    overflow-y: auto;
    .swipe {
      height: 25%;
      .van-swipe {
        height: 100%;
      }
    }
    .video_box {
      max-height: 600px;
      margin: 20px 20px 0 20px;
      background: #ffffff;
      // display: flex;
      // align-items: center;
      padding: 20px;
      .video_title {
        font-size: 28px;
        margin-bottom: 20px;
      }
    }
    .navButton_box {
      height: calc(75% - 20px);
      padding: 20px 20px 0 20px;
      .bg_box {
        height: 100%;
        background-image: url("/img/home/home_bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        display: flex;
        .fill_box {
          height: 100%;
          width: 20px;
          background-color: #e9eaec;
        }
        .left,
        .right {
          height: 100%;
          width: calc(50% - 10px);
          .long_box {
            height: 16.67%;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            img {
              width: 35px;
              margin-right: 10px;
              padding-bottom: 20px;
            }
            div {
              font-size: 32px;
              color: #ffffff;
              padding-bottom: 20px;
            }
          }
          .long_box::after {
            content: "";
            border-bottom: 20px solid #e9eaec;
            position: absolute;
            bottom: 0;
            width: 100%;
          }
          .square_box {
            height: 33.33%;
            border-radius: 20px;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .bao {
              padding-bottom: 20px;
            }
            img {
              width: 35px;
            }
            div {
              font-size: 32px;
              color: #ffffff;
            }
          }
          .square_box::after {
            content: "";
            border-bottom: 20px solid #e9eaec;
            position: absolute;
            bottom: 0;
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
